import EnvironmentUtils from '@utils/environments'

const getLinkRel = () => {
  const isWWW = window.location.host.includes('www')
  const isProd = EnvironmentUtils.isProduction()

  if (isWWW && isProd) {
    return 'canonical'
  }

  return undefined
}

export default {
  getLinkRel,
}
